import { makeStyles } from 'tss-react/mui'
import { nunito_sans, lato } from '@styles/fonts'
const useStyles = makeStyles()((theme) => ({
  zenModeCardContainer: {
    border: '1px solid black',
    padding: '20px',
    marginBottom: '0px',
  },
  rootContainer: {
    marginBottom: '110px',
    [theme.breakpoints.down('md')]: {
      marginBottom: '60px',
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: '10px',
    },
  },
  imgContainer: {
    position: 'relative',
    width: '100%',
    height: '371.31px',

    marginBottom: '30px',
    img: {
      width: '100%',
      height: '100%',
      borderRadius: '20px',
    },
    [theme.breakpoints.down('sm')]: {
      widht: '160px',
      height: '163px',
      marginRight: '20px',
      img: {
        width: '100%',
        height: '124.31px !important',
        objectFit: 'cover',

        borderRadius: '20px',
      },
    },
  },
  primaryHeading: {
    fontFamily: nunito_sans.style.fontFamily,
    fontSize: '32px',
    lineHeight: '44px',
    fontWeight: '800',
    textTransform: 'uppercase',
    marginBottom: '10px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: '22px',
      marginBottom: '5px',
    },
  },
  secondaryHeading: {
    fontFamily: lato.style.fontFamily,
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: '400',
    textTransform: 'uppercase',
    color: '#1C1C1C',
    opacity: 0.8,
    marginBottom: '18px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      lineHeight: '14px',
      marginBottom: '5px',
    },
  },
  text: {
    fontFamily: lato.style.fontFamily,
    fontSize: '18px',
    lineHeight: '22px',
    fontWeight: '400',
    color: '#1C1C1C',
    opacity: 0.8,
    width: '95%',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      lineHeight: '14px',
      marginBottom: '5px',
    },
  },
}))

export default useStyles
